import Vue from "vue";
import Router from "vue-router";

import MainNavbar from "@/layout/MainNavbar.vue";
import MainFooter from "@/layout/MainFooter.vue";

// 검색 결과
import SearchPage from "@/pages/jipvio/Search/searchPage.vue";
import SearchResult from "@/pages/jipvio/Search/searchResult.vue";
import SearchPropDetail from "@/pages/jipvio/Search/searchPropDetail.vue";
import SearchPropDetailTest from "@/pages/jipvio/Search/searchPropDetail_copy.vue";

// 방내놓기
import Step from "@/pages/jipvio/RoomOut/step.vue";

// 공통
import DashboardLayout from "@/layout/DashboardLayout.vue";

import NotFound from "@/pages/jipvio/GeneralViews/NotFoundPage.vue";
import Privacy from "@/pages/jipvio/GeneralViews/Privacy.vue";
import Terms from "@/pages/jipvio/GeneralViews/Terms.vue";
// import About from "@/pages/jipvio/GeneralViews/About.vue";
const About = () => import("@/pages/jipvio/GeneralViews/About.vue");
import AboutTest from "@/pages/jipvio/GeneralViews/About_test.vue";

import LoginPage from "@/pages/jipvio/GeneralViews/LoginPage.vue";
import SignUpPage from "@/pages/jipvio/GeneralViews/SignUpPage.vue";

// 마이페이지
import MyPagePPtMgmt from "@/pages/jipvio/mypage/Mypage_pptMgmt.vue";
import MypageContMgmtAgtDetail from "@/pages/jipvio/mypage/Mypage_contMgmt_agt_detail.vue";
import MypageContMgmt from "@/pages/jipvio/mypage/Mypage_contMgmt.vue";
import MyPageLike from "@/pages/jipvio/mypage/Mypage_Like.vue";
import MypageQstList from "@/pages/jipvio/mypage/Mypage_qstList.vue";
import MypageQstRegstr from "@/pages/jipvio/mypage/Mypage_qstRegstr.vue";
import MyPageDash from "@/pages/jipvio/mypage/Mypage_dashbrd.vue";
import MypageEditAccountInfo from "@/pages/jipvio/mypage/Mypage_Edit_Account_Info.vue";

// const MyPagePPtMgmt = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_pptMgmt.vue"
//   );
// const MypageContMgmtAgtDetail = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_contMgmt_agt_detail.vue"
//   );
// const MypageContMgmt = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_contMgmt.vue"
//   );
// const MyPageLike = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_Like.vue"
//   );
// const MypageQstList = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_qstList.vue"
//   );
// const MypageQstRegstr = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_qstRegstr.vue"
//   );
// const MyPageDash = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_dashbrd.vue"
//   );
// const MypageEditAccountInfo = () =>
//   import(
//     /*webpackChunkName: "Mypage"*/ "@/pages/jipvio/mypage/Mypage_Edit_Account_Info.vue"
//   );

// Admin
import AdminDash from "@/pages/jipvio/AdminPage/Admin_dashboard_sh.vue";
import AdminPptMgmtAgt from "@/pages/jipvio/AdminPage/Admin_pptMgmt_agt.vue";
import AdminPptMgmtAgtDetail from "@/pages/jipvio/AdminPage/Admin_pptMgmt_agt_detail.vue";
import AdminPptMgmtLer from "@/pages/jipvio/AdminPage/Admin_pptMgmt_ler.vue";
import AdminPptMgmtLerDetail from "@/pages/jipvio/AdminPage/Admin_pptMgmt_ler_detail.vue";
import AdminMemMgmtAgt from "@/pages/jipvio/AdminPage/Admin_memMgmt_agt.vue";
import AdminMemMgmtAgtDetail from "@/pages/jipvio/AdminPage/Admin_memMgmt_agt_detail.vue";
import AdminMemMgmtLer from "@/pages/jipvio/AdminPage/Admin_memMgmt_ler.vue";
import AdminMemMgmtLerDetail from "@/pages/jipvio/AdminPage/Admin_memMgmt_ler_detail.vue";
import AdminMemMgmtLee from "@/pages/jipvio/AdminPage/Admin_memMgmt_lee.vue";
import AdminMemMgmtLeeDetail from "@/pages/jipvio/AdminPage/Admin_memMgmt_lee_detail.vue";
import AdminBoardMgmtNoti from "@/pages/jipvio/AdminPage/Admin_boardMgmt_noti.vue";
import AdminBoardMgmtNotiRegstr from "@/pages/jipvio/AdminPage/Admin_boardMgmt_noti_Regstr.vue";
import AdminBoardMgmtQst from "@/pages/jipvio/AdminPage/Admin_boardMgmt_qst.vue";
import AdminBoardMgmtQstRegstr from "@/pages/jipvio/AdminPage/Admin_boardMgmt_qst_Regstr.vue";

// const AdminDash = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_dashboard_sh.vue"
//   );
// const AdminPptMgmtAgt = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_pptMgmt_agt.vue"
//   );
// const AdminPptMgmtAgtDetail = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_pptMgmt_agt_detail.vue"
//   );
// const AdminPptMgmtLer = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_pptMgmt_ler.vue"
//   );
// const AdminPptMgmtLerDetail = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_pptMgmt_ler_detail.vue"
//   );
// const AdminMemMgmtAgt = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_agt.vue"
//   );
// const AdminMemMgmtAgtDetail = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_agt_detail.vue"
//   );
// const AdminMemMgmtLer = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_ler.vue"
//   );
// const AdminMemMgmtLerDetail = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_ler_detail.vue"
//   );
// const AdminMemMgmtLee = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_lee.vue"
//   );
// const AdminMemMgmtLeeDetail = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_memMgmt_lee_detail.vue"
//   );
// const AdminBoardMgmtNoti = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_boardMgmt_noti.vue"
//   );
// const AdminBoardMgmtNotiRegstr = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_boardMgmt_noti_Regstr.vue"
//   );
// const AdminBoardMgmtQst = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_boardMgmt_qst.vue"
//   );
// const AdminBoardMgmtQstRegstr = () =>
//   import(
//     /*webpackChunkName : "Admin"*/ "@/pages/jipvio/AdminPage/Admin_boardMgmt_qst_Regstr.vue"
//   );

import { Loading } from "element-ui";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      components: {
        default: SearchPage,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        // footer: { backgroundColor: "white" },
        // header: { colorOnScroll: 500 },
      }
    },
    {
      path: "/step",
      components: { default: Step, header: MainNavbar, footer: MainFooter }
    },
    {
      path: "/login",
      components: {
        default: LoginPage,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/signup",
      components: {
        default: SignUpPage,
        header: MainNavbar,
        footer: MainFooter
      }
    },

    {
      path: "/mystep",
      components: {
        default: SignUpPage,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/terms",
      components: {
        default: Terms,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/privacy",
      components: {
        default: Privacy,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/about",
      name: "About",
      components: {
        default: About,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/abouttest",
      components: {
        default: AboutTest,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/search/result",
      components: {
        default: SearchResult,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/prop/detail",
      components: {
        default: SearchPropDetail,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/prop/detailTest",
      components: {
        default: SearchPropDetailTest,
        header: MainNavbar,
        footer: MainFooter
      }
    },
    {
      path: "/mypage",
      components: {
        default: DashboardLayout,
        header: MainNavbar,
        footer: MainFooter
      },
      name: "mypage",
      redirect: "/mypage/dash",
      children: [
        {
          path: "ppt/mgmt",
          name: "pptMgmt",
          components: {
            mypage: MyPagePPtMgmt
          }
        },
        {
          path: "cont/mgmt",
          name: "contMgmt",
          components: {
            mypage: MypageContMgmt
          }
        },
        {
          path: "cont/mgmt/agt/detail",
          name: "contMgmtAgtDetail",
          components: {
            mypage: MypageContMgmtAgtDetail
          }
        },

        {
          path: "like",
          name: "Like",
          components: {
            mypage: MyPageLike
          }
        },
        {
          path: "qst/list",
          name: "qstList",
          components: {
            mypage: MypageQstList
          }
        },
        {
          path: "qst/register",
          name: "qstRegstr",
          components: {
            mypage: MypageQstRegstr
          }
        },
        {
          path: "dash",
          name: "dash",
          components: {
            mypage: MyPageDash
          }
        },
        {
          path: "edit/account",
          name: "editAccount",
          components: {
            mypage: MypageEditAccountInfo
          }
        },
        {
          path: "admin/dash",
          name: "admindash",
          components: {
            mypage: AdminDash
          }
        },

        {
          path: "admin/ppt/ler",
          name: "adminPptLer",
          components: {
            mypage: AdminPptMgmtLer
          }
        },
        {
          path: "admin/ppt/ler/detail",
          name: "adminPptLerDetail",
          components: {
            mypage: AdminPptMgmtLerDetail
          }
        },
        {
          path: "admin/ppt/agt",
          name: "adminPptAgt",
          components: {
            mypage: AdminPptMgmtAgt
          }
        },

        {
          path: "admin/ppt/agt/detail",
          name: "adminPptAgtDetail",
          components: {
            mypage: AdminPptMgmtAgtDetail
          }
        },

        {
          path: "admin/mem/ler",
          name: "adminMemLer",
          components: {
            mypage: AdminMemMgmtLer
          }
        },
        {
          path: "admin/mem/ler/detail",
          name: "adminMemLerDetail",
          components: {
            mypage: AdminMemMgmtLerDetail
          }
        },
        {
          path: "admin/mem/agt",
          name: "adminMemAgt",
          components: {
            mypage: AdminMemMgmtAgt
          }
        },
        {
          path: "admin/mem/agt/detail",
          name: "adminMemAgtDetail",
          components: {
            mypage: AdminMemMgmtAgtDetail
          }
        },

        {
          path: "admin/mem/lee",
          name: "adminMemLee",
          components: {
            mypage: AdminMemMgmtLee
          }
        },
        {
          path: "admin/mem/lee/detail",
          name: "adminMemLeeDetail",
          components: {
            mypage: AdminMemMgmtLeeDetail
          }
        },
        {
          path: "admin/board/noti",
          name: "adminBoadrNoti",
          components: {
            mypage: AdminBoardMgmtNoti
          }
        },
        {
          path: "admin/board/noti/regstr",
          name: "adminBoadrNotiRegstr",
          components: {
            mypage: AdminBoardMgmtNotiRegstr
          }
        },
        {
          path: "admin/board/qst",
          name: "adminBoadrQst",
          components: {
            mypage: AdminBoardMgmtQst
          }
        },
        {
          path: "admin/board/qst/regstr",
          name: "adminBoadrQstRegstr",
          components: {
            mypage: AdminBoardMgmtQstRegstr
          }
        }
      ]
    },
    { path: "*", component: NotFound }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// Jipvio Global Loading - loading during pagination
let jipvioGlobalLoading;
router.beforeEach((to, from, next) => {
  jipvioGlobalLoading = Loading.service({
    lock: true,
    text: "잠시만 기다려주세요!!",
    spinner: "el-icon-loading",
    // customClass: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)"
  });
  next();
});
router.afterEach((to, from) => {
  jipvioGlobalLoading.close();
});

export default router;
